export function formatShortDate(value: string | Date): string {
  const date = new Date(value);
  const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
  const month = date.toLocaleDateString('en-GB', { month: 'short' });
  return `${day} ${month}, ${date.getFullYear()}`;
}

export function formatLongDate(value: string | Date): string {
  return new Date(value).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatTime(value: string | Date): string {
  return new Date(value).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export function formatShortTimeAgo(value: string | Date): string {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1000));
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  return `${Math.floor(days / 365)}y`;
}

function pluralise(count: number, unit: string): string {
  return `${count} ${unit}${count === 1 ? '' : 's'} ago`;
}

export function formatRelativeDate(value: string | Date): string {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1000));
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return pluralise(minutes, 'minute');
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return pluralise(hours, 'hour');
  const days = Math.floor(hours / 24);
  if (days < 7) return pluralise(days, 'day');
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return pluralise(weeks, 'week');
  const months = Math.floor(days / 30);
  if (months < 12) return pluralise(months, 'month');
  return pluralise(Math.floor(days / 365), 'year');
}
